import Nav from '../../../Global/Nav.vue'
export default {
  name: 'WebsitesDomains',
  components: {
    Nav
  },
  data() {
    return {
      domainsKeywords: '',
      domainsList: [],
      domainsLoading: true,
      domainsTotal: 0,
      domainsPage: 1,
      domainsSize: 20,
      addDomainVisible: false,
      addDomainLoading: false,
      addDomainForm: {
        domain: ''
      },
      addDomainRules: {
        domain: [
          { required: true, message: '域名不能为空', trigger: 'commit' }
        ]
      },
      tencent: {
        tlds: [],
        balance: 0,
        templates: []
      },
      registeDomainVisible: false,
      registeDomainLoading: false,
      registeDomainForm: {
        domain: '',
        tld: '.com',
        checked: false,
        template: '',
        payment: '余额支付',
        auto_renew: false
      },
      registeDomainRules: {
        domain: [
          { required: true, message: '域名不能为空', trigger: 'commit' }
        ],
        template: [
          { required: true, message: '必须选择注册主体', trigger: 'commit' }
        ]
      },
      registeDomainCheckRes: {
        available: '',
        reason: '',
        price: 0,
        real_price: 0
      }
    }
  },
  mounted() {
    this.getDomainsList();
  },
  methods: {
    copy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    addDomain() {
      this.addDomainVisible = true;
      this.addDomainLoading = false;
      this.addDomainForm = {
        domain: ''
      }
    },
    async confirmAddDomain() {
      await this.$refs.addDomainForm.validate(valid => {
        if (valid) {
          this.addDomainLoading = true;
          this.$axios.post(`/tencent/domains/create`, this.addDomainForm).then((response) => {
            if (response.data.code === 200) {
              setTimeout(() => {
                this.addDomainLoading = false;
                this.addDomainVisible = false;
                this.getDomainsList();
                this.$notify({
                  title: '提示',
                  message: "添加成功",
                  type: 'success'
                });
              }, 10000);
            }
          }).catch(() => {
            this.addDomainLoading = false;
          });
        }
      })
    },
    async getDomainsList() {
      this.domainsLoading = true;
      await this.$axios.get(`/tencent/domains/list`, {
        params: {
          keywords: this.domainsKeywords,
          page: this.domainsPage,
          size: this.domainsSize
        }
      }).then((response) => {
        this.domainsLoading = false;
        if (response.data.code === 200) {
          this.domainsList = response.data.data.data;
          this.domainsTotal = response.data.data.total;
        }
      });
    },
    changeDomainsSize(val) {
      this.domainsSize = val;
      this.getDomainsList();
    },
    currentDomainsChange(val) {
      this.domainsPage = val;
      this.getDomainsList();
    },
    async toggleDomainAutoRenew(row, index) {
      await this.$axios.post(`/tencent/domains/toggle_renew`, {
        id: row.id,
        auto_renew: row.auto_renew
      }).then(() => { }).catch(() => {
        this.domainsList[index].auto_renew = !row.auto_renew;
      });
    },
    async registeDomain() {
      this.registeDomainForm = {
        domain: '',
        tld: '.com',
        checked: false,
        payment: '余额支付',
        auto_renew: false
      }
      this.registeDomainVisible = true;
      this.registeDomainLoading = true;
      await this.$axios.get(`/tencent/domains/tlds`).then((response) => {
        this.registeDomainLoading = false;
        this.tencent.tlds = response.data.data
      })
    },
    async checkDomain() {
      this.registeDomainCheckRes = {
        available: '',
        reason: '',
        price: 0,
        real_price: 0
      }
      this.registeDomainLoading = true;
      await this.$axios.get(`/tencent/billing/balance`).then((response) => {
        this.tencent.balance = response.data.data;
      })
      await this.$axios.get(`/tencent/domains/templates`).then((response) => {
        this.tencent.templates = response.data.data;
      })
      await this.$axios.get(`/tencent/domains/check?domain=${this.registeDomainForm.domain}&tld=${this.registeDomainForm.tld}`).then((response) => {
        this.registeDomainLoading = false;
        this.registeDomainCheckRes = response.data.data;
      })
    },
    confirmRegisteDomain() {
      if (this.registeDomainForm.checked === false) {
        return false;
      }
      this.$refs.registeDomainForm.validate(valid => {
        if (valid) {
          this.$axios.post(`/tencent/domains/create`, this.registeDomainForm).then((response) => {
            if (response.data.code === 200) {
              this.getDomainsList();
              this.$notify({
                title: '操作成功',
                message: '已提交注册',
                type: 'success'
              });
              this.addDomainVisible = false;
              this.addDomainLoading = false;
            }
          }).catch();
        }
      })
    },
    gotoDnspod(row) {
      this.$router.push({
        name: 'websites_dnspod_detail',
        params: {
          domain: row.domain_name
        }
      });
    },
    addToDnspod(row) {
      this.domainsLoading = true;
      this.$axios.post(`/tencent/domains/add_to_dnspod`, {
        domain: row.domain_name
      }).then((response) => {
        setTimeout(() => {
          this.domainsLoading = false;
          this.getDomainsList();
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.domain_name + '已成功托管',
              type: 'success'
            });
          }
        }, 5000);
      }).catch();
    },
    dissolveDomain(row) {
      this.$axios.post(`/tencent/dnspod/destroy`, {
        domain: row.domain_name
      }).then().catch();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Websites/Domains/script.js